export const hasNoRoles = (userStore) => userStore?.redseaRoles?.length === 0;
